const API_KEY = '17d6162809196615584c8d136415c4fd';
const YT_API_KEY = "AIzaSyBs77EwiNjd_b09mePasW_dKJP7rno9Vuo";

export { YT_API_KEY };
export default API_KEY;